module.exports = __webpack_public_path__ + "static/media/dashboard_off@2x.7051fdc0.svg";